import React from 'react'
import PropTypes from 'prop-types'

function EmailOutboxFilters({
  statusFilter,
  setStatusFilter,
  templateFilter,
  setTemplateFilter,
  cycleFilter,
  setCycleFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  searchTerm,
  setSearchTerm,
  uniqueCycles,
}) {
  return (
    <div className="filters-bar mb-3 p-3 bg-light rounded">
      <div className="row g-2">
        <div className="col-12 col-md-3">
          <label className="form-label small" htmlFor="outbox-status-filter">
            Status
          </label>
          <select
            id="outbox-status-filter"
            className="form-select form-select-sm"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Statuses</option>
            <option value="draft">Draft</option>
            <option value="sent">Sent</option>
            <option value="failed">Failed</option>
            <option value="canceled">Canceled</option>
            <option value="test_sent">Test Sent</option>
          </select>
        </div>

        <div className="col-12 col-md-3">
          <label className="form-label small">Email Type</label>
          <select
            className="form-select form-select-sm"
            value={templateFilter}
            onChange={(e) => setTemplateFilter(e.target.value)}
          >
            <option value="">All Types</option>
            <option value="availability_missing">Availability Missing</option>
            <option value="response_needed">Response Needed</option>
            <option value="ready_no_proposal">Ready, No Proposal</option>
          </select>
        </div>

        <div className="col-12 col-md-2">
          <label className="form-label small">Cycle/Week</label>
          <select
            className="form-select form-select-sm"
            value={cycleFilter}
            onChange={(e) => setCycleFilter(e.target.value)}
          >
            <option value="">All Cycles</option>
            <option value="current">This Week</option>
            {uniqueCycles.map((cycle) => (
              <option key={cycle} value={cycle}>
                {cycle}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-2">
          <label className="form-label small">Start Date</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="col-12 col-md-2">
          <label className="form-label small">End Date</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <div className="col-12 col-md-4">
          <label className="form-label small" htmlFor="outbox-search">
            Search
          </label>
          <input
            id="outbox-search"
            type="search"
            className="form-control form-control-sm"
            placeholder="Search email, player, subject, status..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}

EmailOutboxFilters.propTypes = {
  statusFilter: PropTypes.string.isRequired,
  setStatusFilter: PropTypes.func.isRequired,
  templateFilter: PropTypes.string.isRequired,
  setTemplateFilter: PropTypes.func.isRequired,
  cycleFilter: PropTypes.string.isRequired,
  setCycleFilter: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  setStartDate: PropTypes.func.isRequired,
  endDate: PropTypes.string.isRequired,
  setEndDate: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  uniqueCycles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default EmailOutboxFilters
